//----------------------------------------------------
// Project js file
//----------------------------------------------------

import Loader from "./parts/Loader.js";
import navigation from "./parts/navigation.js";
import Smooth from "./parts/Smooth.js";
import Accordion from "./parts/Accordion.js";
// import MouseStalker from "./parts/MouseStalker.js";
import Swiper from "swiper/bundle";
import "swiper/swiper-bundle.css";

import "./parts/vue.js";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import { ScrollSmoother } from 'gsap/ScrollSmoother'

gsap.registerPlugin(ScrollTrigger);

// スムーススクロール実装
//----------------------------------------------------
// gsap.registerPlugin(ScrollSmoother)
navigation();

// ----------------------------------------------------
// ローダー
// ----------------------------------------------------
const loader = new Loader({
  endFn: () => {
    console.log("load end");
  },
});

// ----------------------------------------------------
// トップページスクロール開始時のアニメーション
// ----------------------------------------------------
const scrollNav = document.querySelector(".scroll-nav");
if (scrollNav) {
  gsap.to(scrollNav, {
    scrollTrigger: {
      trigger: ".frontpage__main",
      start: "top bottom",
      toggleActions: "play none none reverse",
      toggleClass: { targets: ".scroll-nav", className: "remove" },
    },
  });
}

// ----------------------------------------------------
// 内部リンク
// ----------------------------------------------------
const smooth = new Smooth({
  linkTarget: '.nav_link a[href*="#"]',
  breakPoint: 768, // px
  pcWaitTime: 500, // ms
  spWaitTime: 500, // ms
  exceptionId: ["exceptionId"], // 例外用のID
  exceptionFn: (id) => {
    // 例外処理
  },
});

// ----------------------------------------------------
//　当社の実績 pc用hoverアニメーション
// ----------------------------------------------------
const workItem = gsap.utils.toArray(".fWork_wrapper-left > .fWork_item");
if (workItem) {
  const workImgItem = gsap.utils.toArray(
    ".fWork_wrapper-right > .fWork_img-block"
  );
  workItem.forEach((item, index) => {
    item.addEventListener("mouseover", () => {
      workImgItem[index].classList.add("active");
    });
    item.addEventListener("mouseleave", () => {
      workImgItem[index].classList.remove("active");
    });
  });
}

// ----------------------------------------------------
//　当社の実績一覧ページ pc用フェードアニメーション
// ----------------------------------------------------
const fadeinItems = gsap.utils.toArray(".fadein");
if (fadeinItems) {
  fadeinItems.forEach((elm, index) => {
    gsap.fromTo(
      elm,
      {
        opacity: 0,
        translateY: "50px",
      },
      {
        opacity: 1,
        translateY: 0,
        delay: 0,
        duration: 0.5,
        // ease: 'ease-out',
        scrollTrigger: {
          trigger: elm,
          start: "top 80%",
          toggleActions: "play none none play",
        },
      }
    );
  });
}

// ----------------------------------------------------
// TOPページ イベント スライダー
// ----------------------------------------------------
const eventContainer = document.querySelector(".fEvent_swiper-container");

if (eventContainer) {
  const breakPoint = 768;
  let eventSwiper;
  let mySwiperBool;
  const createSwiper = () => {
    const option = {
      loop: false,
      speed: 600,
      centeredSlides: false,
      slidesPerView: "auto",
      spaceBetween: 20,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },
    };
    eventSwiper = new Swiper(eventContainer, option);
  };

  if (breakPoint < window.innerWidth) {
    mySwiperBool = false;
  } else {
    createSwiper();
    mySwiperBool = true;
  }

  window.addEventListener(
    "resize",
    () => {
      if (breakPoint < window.innerWidth && mySwiperBool) {
        eventSwiper.destroy(false, true);
        mySwiperBool = false;
      } else if (breakPoint >= window.innerWidth && !mySwiperBool) {
        createSwiper();
        mySwiperBool = true;
      }
    },
    false
  );
}

// ----------------------------------------------------
// TOPページ イベント スライダー
// ----------------------------------------------------
const landContainer = document.querySelector(".fLand_swiper-container");

if (landContainer) {
  const breakPoint = 768;
  let eventSwiper;
  let mySwiperBool;
  const createSwiper = () => {
    const option = {
      loop: false,
      speed: 600,
      centeredSlides: false,
      slidesPerView: "auto",
      spaceBetween: 20,
      scrollbar: {
        el: ".swiper-scrollbar",
        hide: false,
        draggable: true,
      },
    };
    eventSwiper = new Swiper(landContainer, option);
  };

  if (breakPoint < window.innerWidth) {
    mySwiperBool = false;
  } else {
    createSwiper();
    mySwiperBool = true;
  }

  window.addEventListener(
    "resize",
    () => {
      if (breakPoint < window.innerWidth && mySwiperBool) {
        eventSwiper.destroy(false, true);
        mySwiperBool = false;
      } else if (breakPoint >= window.innerWidth && !mySwiperBool) {
        createSwiper();
        mySwiperBool = true;
      }
    },
    false
  );
}
// ----------------------------------------------------
// モデルハウス詳細ページ スライダー
// ----------------------------------------------------
const bannerContainer = document.querySelector(".fBanner_container-swiper");
if (bannerContainer) {
  const bannerSwiper = new Swiper(bannerContainer, {
    loop: true,
    centeredSlides: true,
    spaceBetween: 20,
    slidesPerView: "auto",
    speed: 500,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
      reverseDirection: false,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
  });
}

// ----------------------------------------------------
// モデルハウス詳細ページ スライダー
// ----------------------------------------------------
const modelhouseSlideContainer = document.querySelector(
  ".modelhouse-container-slide"
);
if (modelhouseSlideContainer) {
  const modelhouseSwiper = new Swiper(modelhouseSlideContainer, {
    loop: true,
    centeredSlides: true,
    slidesPerView: "auto",
    speed: 500,
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
      reverseDirection: false,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

// ----------------------------------------------------
// 当社の実績詳細ページ スライダー
// ----------------------------------------------------
const workSlideContainer = document.querySelector(".workimgs-container-swiper");
if (workSlideContainer) {
  const workSwiper = new Swiper(workSlideContainer, {
    loop: true,
    speed: 900,
    effect: "fade",
    centeredSlides: true,
    slidesPerView: "auto",
    autoplay: {
      delay: 8000,
      disableOnInteraction: false,
      reverseDirection: false,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "bullets",
      clickable: true,
    },
    // Navigation arrows
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

// ----------------------------------------------------
// アコーディオンメニュー
// ----------------------------------------------------
// FAQ
const faqList = gsap.utils.toArray(".pageFaq_item");
if (faqList.length) {
  const navAcordion = new Accordion(faqList, {
    // toggleBtnClass: '',
    // itemClass: '',
    firstDisplay: false,
    onlyDisplay: true,
    onChange: (elm, value, i) => {
      const activeBtns = gsap.utils.toArray(".pageFaq_item-toggle.active");
      activeBtns.forEach((elm) => {
        elm.classList.remove("active");
      });
      const btn = gsap.utils.toArray(".pageFaq_item-toggle", elm);
      if (value) {
        btn.forEach((elm) => {
          elm.classList.add("active");
        });
      } else {
        btn.forEach((elm) => {
          elm.classList.remove("active");
        });
      }
    },
  });
}
